import { render, staticRenderFns } from "./ProductItemLinkCreate.vue?vue&type=template&id=71d9973c&"
import script from "./ProductItemLinkCreate.vue?vue&type=script&lang=js&"
export * from "./ProductItemLinkCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports